import { render, staticRenderFns } from "./NextMoveLoading.vue?vue&type=template&id=aa2e6cba&scoped=true"
import script from "./NextMoveLoading.vue?vue&type=script&lang=ts"
export * from "./NextMoveLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2e6cba",
  null
  
)

export default component.exports